var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_887_7879",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H100V100H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_887_7879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.93 19.1164H96.7489C98.337 19.1164 99.1323 21.0367 98.0093 22.1596L40.8517 79.3174C39.8487 80.3203 38.4884 80.8838 37.07 80.8838H3.25109C1.663 80.8838 0.86749 78.9635 1.99054 77.8406L59.1483 20.6828C60.1513 19.6799 61.5116 19.1164 62.93 19.1164Z",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3672 80.6736L85.7144 19.3263",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2773 26.6792L75.7352 19.2214",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4941 80.4636L63.2353 31.7226",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1934 46.8486L65.7566 54.4121",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5879 34.2431L53.1514 41.8064",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3359 80.8838H90.5996",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3);
export default __webpack_public_path__ + "static/media/s3.9d3f93c78c4513bc9596a4684926a0ab.svg";
export { ForwardRef as ReactComponent };